import { SearchOutlined } from '@ant-design/icons';
import { SubmitButton } from '@framework/form/form/submit/SubmitButton.tsx';
import { Card, Flex } from 'antd';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { InquiryFilterFormFields } from './InquiryFilterFormFields.tsx';

const FilterCard = styled(Card)`
  .ant-card-body {
    padding: 12px;
  }
`;
const FilterButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const FilterCardTitle = styled.div`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3}px;
    font-family: ${props => props.theme.fontFamily};
    margin-bottom: 0.5em;
    line-height: 1.3;
    font-weight: 600;
  }
`;

export interface IInquiryFilterFormProps {
  buttons?: React.ReactNode;
}

/**
 * Form per la ricerca di domande FrontOffice.
 */
export function InquiryFilterForm(props: IInquiryFilterFormProps) {
  const { t } = useTranslation();

  return (
    <FilterCard>
      <div role="search" aria-label="Filtri di ricerca domande">
        <FilterCardTitle>
          {t('inquiry.filtri-di-ricerca', 'Filtri di ricerca')}
        </FilterCardTitle>

        <InquiryFilterFormFields />

        <Flex vertical gap={12}>
          <SubmitButton
            block
            pristineMessage={t(
              'ui.nessun-filtro-modificato',
              'Nessun filtro modificato',
            )}
            type="primary"
            icon={<SearchOutlined aria-hidden />}
          >
            {t('inquiry.cerca', 'Cerca')}
          </SubmitButton>
          {props.buttons}
        </Flex>
      </div>
    </FilterCard>
  );
}
